// Utility: get display name for social skill category in current language
export function getCategoryDisplayName(catKey, lang = 'en') {
  // Define your category translations here
  const categoryTranslations = {
    Greetings_Communication: {
      en: 'Greetings & Communication',
      fr: 'Salutations & Communication',
      'zh-TW': '問候與溝通',
      'zh-CN': '问候与沟通'
    },
    Play_PeerInteraction: {
      en: 'Play & Peer Interaction',
      fr: 'Jeu & Interaction avec les pairs',
      'zh-TW': '遊戲與同儕互動',
      'zh-CN': '游戏与同伴互动'
    },
    EmotionalSkills: {
      en: 'Emotional Skills',
      fr: 'Compétences émotionnelles',
      'zh-TW': '情緒技巧',
      'zh-CN': '情绪技巧'
    },
    Classroom_SchoolSkills: {
      en: 'Classroom & School Skills',
      fr: 'Compétences en classe et à l’école',
      'zh-TW': '課堂與學校技巧',
      'zh-CN': '课堂与学校技巧'
    },
    SelfCare_Independence: {
      en: 'Self-Care & Independence',
      fr: 'Soins personnels & Indépendance',
      'zh-TW': '自我照顧與獨立',
      'zh-CN': '自我照顾与独立'
    },
    Community_Safety: {
      en: 'Community & Safety',
      fr: 'Communauté & Sécurité',
      'zh-TW': '社區與安全',
      'zh-CN': '社区与安全'
    },
    Perspective_SocialAwareness: {
      en: 'Perspective & Social Awareness',
      fr: 'Perspective & Sensibilisation sociale',
      'zh-TW': '觀點與社會意識',
      'zh-CN': '观点与社会意识'
    }
  };
  const translation = categoryTranslations[catKey];
  if (!translation) return catKey;
  return translation[lang] || translation.en || catKey;
}

export function getScheduleCategoryDisplayName(catKey, lang = 'en') {
  const categoryTranslations = {
    Daily_Living: {
      en: 'Daily Living', fr: 'Vie quotidienne', 'zh-TW': '日常生活', 'zh-CN': '日常生活'
    },
    School: {
      en: 'School', fr: 'École', 'zh-TW': '學校', 'zh-CN': '学校'
    },
    Home: {
      en: 'Home', fr: 'Maison', 'zh-TW': '居家', 'zh-CN': '居家'
    },
    Eating: {
      en: 'Eating', fr: 'Repas', 'zh-TW': '飲食', 'zh-CN': '饮食'
    },
    Community: {
      en: 'Community', fr: 'Communauté', 'zh-TW': '社區', 'zh-CN': '社区'
    },
    Appointments: {
      en: 'Appointments', fr: 'Rendez-vous', 'zh-TW': '預約行程', 'zh-CN': '预约行程'
    },
    Activities: {
      en: 'Activities', fr: 'Activités', 'zh-TW': '活動', 'zh-CN': '活动'
    },
    Travel: {
      en: 'Travel', fr: 'Voyage', 'zh-TW': '旅行', 'zh-CN': '旅行'
    },
    Holidays_Special_Events: {
      en: 'Holidays & Special Events', fr: 'Fêtes et événements spéciaux',
      'zh-TW': '節日與特殊活動', 'zh-CN': '节日与特殊活动'
    },
    Self_Regulation: {
      en: 'Self-Regulation', fr: 'Autorégulation', 'zh-TW': '自我調節', 'zh-CN': '自我调节'
    },
    Safety: {
      en: 'Safety', fr: 'Sécurité', 'zh-TW': '安全', 'zh-CN': '安全'
    }
  };
  const translation = categoryTranslations[catKey];
  if (!translation) return catKey;
  return translation[lang] || translation.en || catKey;
}

export function getScheduleSkillDisplayName(skillKey, category, lang = 'en') {
  const skills = scheduleCategoriesData[category] || [];
  const skill = skills.find((item) => item.key === skillKey);
  if (!skill) return skillKey;
  return skill[lang] || skill.en || skill.key;
}
import { scheduleCategoriesData } from './staticData';
